$bog_card_tag $mol_text
